export const PAGE = { w: 1440, h: 810 };

export const frameMap = (frames) => Object.fromEntries(frames.map((f) => [f.key, f]));

export const SHEET_FRAME = { key: "sheet", label: "Data sheet photo", role: "half-page photo next to the price table", x: 0, y: 0, w: 685, h: 685, sheet: true };

export function cropBox(iw, ih, sw, sh, cx = 0.5, cy = 0.5, zoom = 1) {
  const a = sw / sh;
  let bw, bh;
  if (iw / ih > a) { bh = ih; bw = ih * a; } else { bw = iw; bh = iw / a; }
  const z = Math.max(1, zoom || 1);
  bw /= z; bh /= z;
  const x0 = Math.min(Math.max(cx * iw - bw / 2, 0), iw - bw);
  const y0 = Math.min(Math.max(cy * ih - bh / 2, 0), ih - bh);
  return [x0, y0, bw, bh];
}

export function cropStyle(ref, d, s) {
  const [x0, y0, bw, bh] = cropBox(ref.width || 1, ref.height || 1, d.w, d.h, s.cx, s.cy, s.zoom);
  return {
    position: "absolute", maxWidth: "none",
    width: `${(ref.width / bw) * 100}%`, height: `${(ref.height / bh) * 100}%`,
    left: `${(-x0 / bw) * 100}%`, top: `${(-y0 / bh) * 100}%`,
  };
}

export function defaultSlots(images, frames) {
  if (!images.length) return [];
  return frames.map((f, i) => {
    const rep = Math.floor(i / images.length);
    return { slot: f.key, image: images[i % images.length].path, cx: [0.5, 0.3, 0.7, 0.5][rep % 4], cy: 0.55, zoom: 1 + rep * 0.9, why: "" };
  });
}

// Mirrors backend layouts.resolve_slots: same key first, then same position, then spare photos.
export function fitSlots(slots, frames, images) {
  const paths = new Set(images.map((i) => i.path));
  const saved = slots.filter((s) => s.image && paths.has(s.image) && s.slot !== "sheet");
  const byKey = Object.fromEntries(slots.filter((s) => s.image && paths.has(s.image)).map((s) => [s.slot, s]));
  const fallback = defaultSlots(images, frames);
  return frames.map((f, i) => (f.sheet ? { ...(byKey.sheet || { image: images[0]?.path, cx: 0.5, cy: 0.5, zoom: 1, why: "" }), slot: "sheet" }
    : { ...(byKey[f.key] || saved[i] || fallback[i] || {}), slot: f.key }));
}

export const pct = (v, total) => `${(v / total) * 100}%`;
